import { GuestFormDataFields, GuestFormMixed } from '@chilipiper/api-client/src/meeting-types'

export const isMixedGuestForm = (
  guestForm?: GuestFormDataFields | GuestFormMixed
): guestForm is Extract<GuestFormDataFields | GuestFormMixed, { type: 'Mixed' }> =>
  guestForm?.type === 'Mixed'
